import { Box, Container, Grid, GridItem, Heading, SimpleGrid, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react"
import styled from "styled-components"
import dataProfile from "../data"

const ContainerTab = styled.div`
  /* width: 100%; */
  background-color: #f7f8fd;
`

const StyledTabpanel = styled(TabPanel)`
  display: flex;
  flex-wrap: wrap;
  grid-template-columns: 1fr 6fr 1fr;
  gap: 16px;
  /* background-color: red; */
`

const StyledGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 16px;
`

const Column = styled.div`
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  width: 49%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const PositionTab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const StyledTab = styled(Tab)`
  border-radius: 16px;
  background-color: #f0f0f0;
  padding: 8px 16px;
  margin-right: 8px;
  /* width: 100%; */
  cursor: pointer;
  gap: 8px;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: #e0e0e0;
  }

  &.chakra-tabs__tab--selected {
    background-color: #2347f9;
    color: white;

    &:hover {
      background-color: #2347f9;
    }
  }
`

const StyledTitle = styled.h6`
  font-size: 20px;
  font-weight: 500px;
  color: gray;
  margin-top: 30px;
`

const StyledYear = styled.h6`
  font-size: 15px;
  font-weight: 500px;
  color: gray;
  margin-top: 30px;
`

const TabPortofolio = () => {
  return (
    <>
      <ContainerTab>
       <Container maxW={'7xl'}>
         <Stack
          as={'Box'}
          textAlign={'center'}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 10, md: 36 }}
         >
          <Heading
            lineHeight={1.1}
            fontWeight={600}
            fontSize={{ base: "3xl", sm: "4xl", lg: "6xl" }}
          >
            <Text as={'span'} color={"#2347f9"}>
              Projects
            </Text>
          </Heading>
          <Tabs variant={'soft-rounded'} isFitted>
            <PositionTab>
              <TabList style={{ gap: '30px', display: 'flex' }}>
                {dataProfile.map((val) => (
                  <StyledTab key={val.id}>{val.name}</StyledTab>
                ))}
              </TabList>
            </PositionTab>

            <TabPanels>
              {dataProfile?.map((item) => (
                <Box key={item?.id}>
                  <StyledGrid>
                    {item?.project?.map((value) => (
                      <StyledTabpanel key={value?.id}>
                        <Column onClick={() => window.open(value.link)}>
                          <img src={value.image} alt={value.title} />
                          <StyledTitle>
                            {value.title}
                          </StyledTitle>
                          <StyledYear>
                            {value.year}
                          </StyledYear>
                        </Column>
                      </StyledTabpanel>
                    ))}
                  </StyledGrid>

                  <StyledGrid>
                    {item?.RnD?.map((val) => (
                      <TabPanel key={val.id}>
                        <Column onClick={() => window.open(val.link)}>
                          <img src={val.image} alt={val.title} />
                          <StyledTitle>
                            {val.title}
                          </StyledTitle>
                          <StyledYear>
                            {val.year}
                          </StyledYear>
                        </Column>
                      </TabPanel>
                    ))}
                  </StyledGrid>
                </Box>
              ))}
            </TabPanels>
          </Tabs>
         </Stack>
       </Container>
      </ContainerTab>
    </>
  )
}

export default TabPortofolio